import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SoundService {
    private readonly notificationSound = new Audio('/assets/audio/notification.mp3');
    private readonly sendMessageSound = new Audio('/assets/audio/send_message.mp3');

    public playNotificationSound(): void {
        this.notificationSound.currentTime = 0; // Réinitialise le son au début
        this.notificationSound.volume = 1; // 1 = 100%
        this.notificationSound.play().catch((error) => {
            console.error('Impossible de lire le son :', error);
        });
    }

    public playSendMessageSound(): void {
        this.sendMessageSound.currentTime = 0; // Réinitialise le son au début
        this.notificationSound.volume = 1; // 1 = 100%
        this.sendMessageSound.play().catch((error) => {
            console.error('Impossible de lire le son :', error);
        });
    }
}
